import Cookies from 'js-cookie';

// takes a value such as #{SomeOctopusVariable} and returns process.env.SomeOctopusVariable
// this could be useful in the future if we decide to make this app run server-side (has no effect for client-side code)
const getEnvValue = (templateName) => process.env[templateName.substr(2, templateName.length - 3)];

// if templateValue has not been replaced by octopus, returns that,
// otherwise, returns the environment variable if it's set,
// otherwise, returns the specified default value
const getConfigValue = (templateValue, defaultValue) =>
  templateValue.indexOf('#{') === -1 ? templateValue : getEnvValue(templateValue) || defaultValue;

const beastMode = Cookies.get('beast_mode');

const config = {
  beastMode,
  graphQLUri: getConfigValue(
    'https://forecasts-premium-webapi-subscription.emarketer.com/graphql',
    'https://forecasts-premium-webapi-subscription.preview1.emarketer.com/graphql'
  ),
  enableGrowthPage:
    beastMode || (getConfigValue('', 'false') || '').toString().toLowerCase() === 'true',
  enableStatsPage:
    beastMode || (getConfigValue('', 'false') || '').toString().toLowerCase() === 'true',
  enableTaxonomyPage:
    beastMode ||
    (getConfigValue('', 'false') || '').toString().toLowerCase() === 'true',
  enableDemographicsPage:
    beastMode ||
    (getConfigValue('', 'false') || '').toString().toLowerCase() === 'true',
  enableMetricSearch:
    beastMode ||
    (getConfigValue('', 'false') || '').toString().toLowerCase() === 'true',
  enableLogarithmic:
    beastMode || (getConfigValue('', 'false') || '').toString().toLowerCase() === 'true',
  enableStacked:
    beastMode || (getConfigValue('', 'false') || '').toString().toLowerCase() === 'true',
  enableMetricDetails:
    beastMode ||
    (getConfigValue('', 'false') || '').toString().toLowerCase() === 'true',
  loginComponentUrl: getConfigValue(
    'https://subscriptions.emarketer.com/LoginOrSignupComponent/build/loginorsignupcomponent-inline.js',
    'https://subscriptions.preview1.emarketer.com/LoginOrSignupComponent/build/loginorsignupcomponent-inline.js'
  ),
  brandingUrl: getConfigValue(
    'https://branding-na1.emarketer.com/app/6.0/build/branding.js',
    'https://branding.preview1.emarketer.com/app/6.0/build/branding.js'
  ),
  footerUrl: getConfigValue(
    'https://branding-na1.emarketer.com/footer/2.0/build/footer.js',
    'https://branding.preview1.emarketer.com/footer/2.0/build/footer.js'
  ),
  enableAuth: (getConfigValue('', 'false') || '').toString().toLowerCase() === 'true', // make false to disable auth for api
  authCookieName: getConfigValue('em_at', 'em_at'),
  chartLib: getConfigValue('chartjs', 'chartjs'),
  basename: getConfigValue('#{REACT_APP_BASENAME', ''),
  publicUrl: getConfigValue('', ''),
  analyticsUrl: getConfigValue('https://analytics-na1.emarketer.com/lib/1.2/dist/library.min.js', ''),
  applicationReleaseNumber: getConfigValue('', ''),
  fontCssUrl: getConfigValue('https://fonts.emarketer.com/fonts.css', 'https://fonts.emarketer.com/fonts.css'),
  osanoScriptUrl: getConfigValue(
    'https://cmp.osano.com/Azq8alSrat37T4I48/e5bec6e1-e8a6-4269-aec2-3c45025cbf21/osano.js',
    'https://cmp.osano.com/Azq8alSrat37T4I48/e5bec6e1-e8a6-4269-aec2-3c45025cbf21/osano.js'
  ),
  osfScriptUrl: getConfigValue(
    'https://cdn.evgnet.com/beacon/emarketerinc/engage/scripts/evegage.min.js',
    '//cdn.evgnet.com/beacon/emarketerinc/engage/scripts/evergage.min.js'
  ),
  salesForceProxyApiUrl: getConfigValue(
    'https://www.emarketer.com/salesforceproxy/webapi',
    'https://www.preview1.emarketer.com/salesforceproxy/webapi'
  ),

  // VD: question - the `7452` form maps to `7015d000002RP62AAG` campaign, which is `Learn More - Industry KPIs` campaign ¯\_(ツ)_/¯ (wrong service?)
  sfmcProPlusFormId: parseInt(getConfigValue('7452', '7452')),

  sfdcFreemiumProPlusInquiryCampaignId: getConfigValue(
    '701TR00000JwImRYAV',
    '701TH000009wGTvYAM'
  ),
  apiKey: getConfigValue('DIAD-234FD4-IJFADFAW-23E3', 'DIAD-234FD4-IJFADFAW-23E3'),
  baseUrl: getConfigValue('https://www.emarketer.com', 'https://www.preview1.emarketer.com'),


  commonSubscriptionsServiceUrl: getConfigValue(
    'https://subscriptions-na1.emarketer.com',
    'https://subscriptions-na1.preview1.emarketer.com'
  ),

  currentEnvironment: getConfigValue('production', 'development'),

  commonGeolocationUtilityUrl : getConfigValue(
    'https://www.emarketer.com/geolocationutility/webapi',
    'https://www.preview1.emarketer.com/geolocationutility/webapi'
  ),

  chilipiperConciergeScriptUrl: getConfigValue(
    'https://emarketer.chilipiper.com/concierge-js/cjs/concierge.js',
    'https://emarketer.chilipiper.com/concierge-js/cjs/concierge.js'
  )
};

export default config;
